import { getLanguage } from "config/language";
import React from "react";

export default function TextBannerArea({ ekkLanguage }) {
	return (
		<div className='w-full lg:w-1/2 mb-8 lg:mb-0'>
			<div className='w-full animate-fade-in'>
				<h1
					className={`${
						getLanguage() === "en"
							? "text-3xl md:text-4xl lg:text-5xl"
							: "text-2xl md:text-3xl lg:text-4xl"
					} font-bold text-gray-800 pb-4 text-center lg:text-left leading-tight`}>
					{ekkLanguage.landing.header1}
				</h1>
				<h2
					className={`${
						getLanguage() === "en"
							? "text-2xl md:text-3xl lg:text-4xl"
							: "text-xl md:text-2xl lg:text-3xl"
					} font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-orange-500 to-orange-600 text-center lg:text-right flex flex-wrap justify-center lg:justify-end leading-tight`}>
					{ekkLanguage.landing.header2}
				</h2>
				<p className='mt-6 text-gray-600 text-center lg:text-left text-base md:text-lg'>
					{ekkLanguage.landing.subheader || 'Join our community of volunteers making a difference'}
				</p>
			</div>
		</div>
	);
}
